export const ageMethod = "age nearest";
export const gateway = "https://sbx-cmf-shopper-api.link-nonprod.wawanesalife.com";
export const assets = "https://sbx-assets.link-nonprod.wawanesalife.com/brokers/cmf";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJjbWYiLCJuYW1lIjoiY21mIiwiaWF0IjoxNzQ3MTUxODM4LCJleHAiOjE5MDQ5Mzk4Mzh9.AIAtWoWom7-fYZhjHTOiVIvH1IlMs72T22QTSZsCq68";
export const brokerConfig = {
	enabled: "yes",
	authorized_nb: "yes",
	authorized_mb: "yes",
	authorized_pe: "yes",
	authorized_yt: "yes",
	authorized_sk: "yes",
	authorized_qc: "no",
	authorized_nt: "yes",
	authorized_nu: "yes",
	authorized_ns: "yes",
	authorized_nl: "yes",
	authorized_on: "yes",
	authorized_ab: "yes",
	authorized_bc: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"sbx-cmf-shopper.link-nonprod.wawanesalife.com": {
		a: {
			environment: "sbx",
			broker: "cmf",
			website: "https://clarencemainfinancial.com/",
			accessibilityLink: "https://en.wikipedia.org/wiki/Web_Content_Accessibility_Guidelines",
			themeSwitcher: "show",
			ftcLink: "https://www.fsrao.ca/regulation/guidance/fair-treatment-customers-insurance",
			privacyLink: "https://www.priv.gc.ca/en/privacy-topics/privacy-laws-in-canada/the-personal-information-protection-and-electronic-documents-act-pipeda/",
			layout: "modern",
			scope: "cmf#branding#sbx-cmf-shopper.link-nonprod.wawanesalife.com#a",
			approve_company: "Link Platform",
			email: "team@clarencemainfinancial.com",
			photos: [
				"carousel1.jpg",
				"carousel2.jpg",
				"carousel3.jpg",
				"carousel4.jpg",
				"carousel5.jpg",
				"carousel6.jpg",
				"carousel7.jpg",
				"carousel8.jpg",
				"carousel9.jpg",
				"carousel10.jpg",
				"carousel11.jpg",
			],
			approve_user: "link_cmf",
			logoPosition: "menu",
			environment_id: "sbx",
			brands: [
				"sbx-cmf-shopper.link-nonprod.wawanesalife.com",
			],
			"maps": {
				"True North Tower": [
					"236 Carlton",
					"Winnipeg",
					"MB",
					"R3C 1P5",
				],
				"River Park branch": [
					"845 Dakota St Unit 30",
					"Winnipeg",
					"MB",
					"R2M 5M3",
				],
				"Jack Blick branch": [
					"1440 Jack Blick Ave",
					"Winnipeg",
					"MB",
					"R3G 0L4",
				],
				"Saskatoon branch": [
					"100-3020 Preston Ave S",
					"Saskatoon",
					"SK",
					"S7T 0V2",
				],
				"Waverley branch": [
					"840 Waverley St",
					"Winnipeg",
					"MB",
					"R3T 5Z7",
				],
			},
			phone: "204.555.4321",
			menuPhone: "button",
			ab: "a",
			logo: "a.png",
			brand_name: "sbx-cmf-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			environment: "sbx",
			broker: "cmf",
			website: "https://clarencemainfinancial.com/",
			accessibilityLink: "https://en.wikipedia.org/wiki/Web_Content_Accessibility_Guidelines",
			themeSwitcher: "show",
			ftcLink: "https://www.fsrao.ca/regulation/guidance/fair-treatment-customers-insurance",
			privacyLink: "https://www.priv.gc.ca/en/privacy-topics/privacy-laws-in-canada/the-personal-information-protection-and-electronic-documents-act-pipeda/",
			layout: "modern",
			scope: "cmf#branding#sbx-cmf-shopper.link-nonprod.wawanesalife.com#b",
			approve_company: "Link Platform",
			email: "team@clarencemainfinancial.com",
			photos: [
				"carousel1.jpg",
				"carousel2.jpg",
				"carousel3.jpg",
				"carousel4.jpg",
				"carousel5.jpg",
				"carousel6.jpg",
				"carousel7.jpg",
				"carousel8.jpg",
				"carousel9.jpg",
				"carousel10.jpg",
				"carousel11.jpg",
			],
			approve_user: "link_cmf",
			logoPosition: "menu",
			environment_id: "sbx",
			brands: [
				"sbx-cmf-shopper.link-nonprod.wawanesalife.com",
			],
			"maps": {
				"True North Tower": [
					"236 Carlton",
					"Winnipeg",
					"MB",
					"R3C 1P5",
				],
				"River Park branch": [
					"845 Dakota St Unit 30",
					"Winnipeg",
					"MB",
					"R2M 5M3",
				],
				"Jack Blick branch": [
					"1440 Jack Blick Ave",
					"Winnipeg",
					"MB",
					"R3G 0L4",
				],
				"Saskatoon branch": [
					"100-3020 Preston Ave S",
					"Saskatoon",
					"SK",
					"S7T 0V2",
				],
				"Waverley branch": [
					"840 Waverley St",
					"Winnipeg",
					"MB",
					"R3T 5Z7",
				],
			},
			phone: "204.555.4321",
			menuPhone: "button",
			ab: "b",
			logo: "b.png",
			brand_name: "sbx-cmf-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Tue May 13 2025 10:57:18 GMT-0500 (Central Daylight Time)
